import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import TrafficSourcesChart from './TrafficSourcesChart';
import DeviceBreakdownChart from './DeviceBreakdownChart';
import EngagementTrendChart from './EngagementTrendChart';
import KeywordsLandingPagesTable from './KeywordsLandingPagesTable';
const DigitalAnalyticsDashboard: React.FC = () => {
  const kpis = [{
    title: 'Website Visits',
    value: '185,420',
    change: '+12.5%',
    isPositive: true,
    subtitle: 'Monthly visitors'
  }, {
    title: 'Bounce Rate %',
    value: '42.3%',
    change: '-3.8%',
    isPositive: true,
    subtitle: 'Lower is better'
  }, {
    title: 'Cost Per Click (₹)',
    value: '₹28.50',
    change: '-5.2%',
    isPositive: true,
    subtitle: 'Avg CPC'
  }, {
    title: 'Lead Form Submissions',
    value: '3,842',
    change: '+18.7%',
    isPositive: true,
    subtitle: 'Monthly conversions'
  }];
  return <div data-id="element-7407">
      <DescriptionPanel title="Digital Analytics & Web Performance" description="Comprehensive analysis of website traffic, user behavior, and digital campaign effectiveness. Monitor visitor engagement, traffic sources, device preferences, and conversion paths to optimize digital marketing strategies and improve online presence." insights={['Website visits up 12.5% with 185K monthly visitors', 'Organic search driving 42% of traffic - strongest channel', 'Mobile traffic at 58% - responsive design critical', 'Bounce rate improved to 42.3% through UX optimizations']} data-id="element-7408" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-7409">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-7410">
          Digital Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7411">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-7412">
              <div className="flex flex-col h-full" data-id="element-7413">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-7414">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-7415">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-7416">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-7417">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-7418" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-7419" />}
                  {kpi.change} vs last month
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Main Charts Row 1 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7420">
        <TrafficSourcesChart data-id="element-7421" />
        <DeviceBreakdownChart data-id="element-7422" />
      </div>
      {/* Engagement Trend - Full Width */}
      <EngagementTrendChart data-id="element-7423" />
      {/* Keywords & Landing Pages Table */}
      <KeywordsLandingPagesTable data-id="element-7424" />
    </div>;
};
export default DigitalAnalyticsDashboard;